import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { COLORS } from '../Styles/Colors'; // Adjusted import path
import apiClient from '../Services/ApiClient';
import styled from 'styled-components';
import logo from '../assets/images/AIMS_Logo_color_TM.png'; // Adjust the path to your logo image

const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(135deg, ${COLORS.lightGray} 0%, #e0e0e0 100%);
  padding: 16px;
  box-sizing: border-box;
  overflow-y: auto;
`;

const LoginForm = styled.form`
  background: white;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 420px;
  text-align: center;
  box-sizing: border-box;

  @media (max-width: 600px) {
    padding: 1.5rem 1.25rem;
  }
`;

// Modify Title to be a div instead of h2 since it will contain an image
const Title = styled.div`
  margin-bottom: 1.5rem;
`;

// Add a styled component for the logo
const Logo = styled.img`
  max-width: 250px;
  height: auto;

  @media (max-width: 600px) {
    max-width: 180px;
  }
`;

// Rest of your styled components remain the same
const Input = styled.input`
  width: 100%;
  padding: 0.9rem;
  margin: 0.75rem 0;
  border: 1px solid ${COLORS.gray};
  border-radius: 6px;
  box-sizing: border-box;
  font-size: 1rem;
  transition: border-color 0.2s ease;
  &:focus {
    border-color: ${COLORS.teal};
    outline: none;
    box-shadow: 0 0 4px rgba(0, 128, 128, 0.3);
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 0.9rem;
  margin-top: 1.5rem;
  background-color: ${COLORS.teal};
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 500;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: ${COLORS.darkTeal};
  }
  &:disabled {
    background-color: ${COLORS.gray};
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.p`
  color: ${COLORS.red};
  margin: 0.75rem 0;
  font-size: 0.9rem;
  font-weight: 500;
`;

const ForgotPasswordLink = styled.a`
  display: block;
  margin-top: 1rem;
  color: ${COLORS.teal};
  font-size: 0.9rem;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: ${COLORS.darkTeal};
  }
`;


const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) {
      setError('No token provided in the link');
      return;
    }

    try {
      const response = await apiClient('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to reset password');
      }

      setMessage(data.message);
      setError(null);
      setPassword('');
    } catch (err: any) {
      setError(err.message);
      setMessage(null);
    }
  };

  return (
    <LoginContainer>
    <LoginForm onSubmit={handleSubmit}>
            <Title>
                <Logo src={logo} alt="Company Logo" />
              </Title>
             
              <Input
                type="password"
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              {error && <ErrorMessage>{error}</ErrorMessage>}
              {message && <p style={{ color: COLORS.success }}>{message}</p>}
              <Button type="submit">
                Reset Password
              </Button>
              <ForgotPasswordLink onClick={
                () => {
                  window.location.href = '/';
                }
              }>
                Back to Login
              </ForgotPasswordLink>
            </LoginForm>
            </LoginContainer>
  );
};

export default ResetPassword;